import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import StationeryItemListView from 'src/sections/stationery-item/view/stationery-item-list-view';

export default function StationeryItemListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Stationery Items</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_STATIONERY_ITEM,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <StationeryItemListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
